import { useCallback, useState, useEffect } from 'react';

export const useAdminClientFormValidation = ({
  actualTextContent,
  actualTextWordCount,
  analyseResult,
  formData,
  initialTextWordCount,
  keyword,
  metaDescriptionTag,
  minWords,
  textTitle,
  textType,
  titleTag,
  validTextNbr,
  semanticScore,
}) => {
  const [disabledForm, setDisabledForm] = useState(false);

  const checkValidForm = useCallback(() => {
    // Validation spécifique AdminClient
    const hasRequiredFields = textTitle && keyword;
    const hasValidWordCount = actualTextWordCount >= minWords;
    const hasValidContent = actualTextContent && actualTextContent.trim().length > 0;
    
    // Pour AdminClient, on est plus permissif que l'Admin
    const isValid = hasRequiredFields && hasValidContent;
    
    setDisabledForm(!isValid);
    
    return isValid;
  }, [
    textTitle,
    keyword,
    actualTextContent,
    actualTextWordCount,
    minWords,
  ]);

  useEffect(() => {
    checkValidForm();
  }, [checkValidForm]);

  return {
    checkValidForm,
    disabledForm,
  };
};
